/* CUBE STORE - le "i" di spiegazione

   Tre cerchietti, tutti costruiti allo stesso modo: si preme, si apre
   un pannello sotto, si ripreme e si chiude. Stanno in un file solo
   perche' sono la stessa cosa in tre punti diversi, e tenerli insieme
   evita che fra sei mesi ne esistano tre versioni leggermente diverse.

     .cube-rata     sotto il prezzo, come funziona il pagamento a rate
     .cube-voucher  sotto il prezzo, come funziona il Buono Acquisto
     bonifico del saldo, dentro la finestra del modulo

   PERCHE' UNA "i" E NON IL TESTO SEMPRE IN VISTA
   Le condizioni sono tre o quattro righe l'una: scritte sempre,
   spingono in basso il pulsante di acquisto e vengono lette da
   nessuno. Nascoste del tutto, invece, il negozio promette qualcosa
   senza dire a quali condizioni. La "i" e' il compromesso: sta li'
   piccola, e chi vuole sapere trova tutto in un tocco.

   I TESTI SONO QUELLI DEL NEGOZIO, PAROLA PER PAROLA
   Ci avevo aggiunto in coda al Buono la soglia oltre la quale spetta -
   la stessa che cube-importi.js applica per far comparire la scelta
   "scontalo subito / tienilo per dopo". Il negozio ha deciso di non
   scriverla qui, ed e' una sua scelta: la soglia resta dov'era, nel
   codice che la applica, e non e' piu' ripetuta in questo testo. Se un
   domani dovesse tornare, il numero va letto da window.cubeSogliaBuono
   e non scritto a mano: un numero copiato in un testo e' esattamente il
   tipo di cosa che nessuno si ricorda di aggiornare.

   LA FASCIA DI PREZZO NON E' PIU' SCRITTA NEL TESTO DELLE RATE
   Fino all'11 agosto 2026 qui c'era scritto "offerto sui prodotti da
   1.499 a 5.000 euro". Quel giorno il tetto dei 5.000 e' stato tolto
   dal widget (templates/product.json, blocco "Widget pagamenti"), su
   richiesta di Marco: la rata compare adesso a qualunque prezzo, e una
   "i" che continuava a dire 5.000 su una bici da 7.000 si smentiva da
   sola. Il limite in basso, 1.499, e' una scelta di vetrina e non una
   condizione del finanziamento, quindi non va scritta qui.

   11 AGOSTO 2026 - TESTO DELLE RATE RISCRITTO DAL NEGOZIO
   Il testo di testoRate() e' arrivato gia' scritto dallo store e
   sostituisce quello precedente, che era:
     "Dividi il prezzo in 20 rate mensili senza interessi: TAN 0%,
      TAEG 0%, nessun costo aggiuntivo. La rata indicata e' il prezzo
      diviso venti. Il pagamento a rate e' soggetto all'approvazione di
      HeyLight."
   Due cose sono cambiate di sostanza, non di forma, e vanno sapute:
   - ENTRA "inizia a pagare fra 30 giorni": e' una condizione del
     contratto che il codice non conosce e non puo' verificare. Se il
     differimento di 30 giorni non e' previsto sul contratto HeyLight
     attivo, questa riga promette una cosa che non c'e'.
   - ESCE "soggetto all'approvazione di HeyLight", sostituito da
     "Approvazione online immediata". Sparisce cosi' l'unico punto in
     cui si diceva che il finanziamento puo' anche essere rifiutato:
     ora si parla solo della velocita' della risposta. Segnalato a
     Marco l'11 agosto 2026, che ha confermato il testo cosi'.
   Resta valido quello che gia' diceva la nota qui sotto: manca il
   collegamento all'informativa precontrattuale.

   ATTENZIONE AI TESTI
   Quelli sulle rate parlano di un prodotto finanziario. Vanno
   confermati da chi risponde di quelle condizioni. Il tetto vero
   del contratto HeyLight va verificato: nel modulo di pagamento la
   voce si chiama ancora "Heylight Dilazione Tan 0 Taeg 0 (Max 5.000
   EUR)", e se quel numero e' ancora valido il widget sta promettendo
   il tasso zero anche dove non spetta. Manca inoltre il collegamento
   all'informativa precontrattuale, che era nel widget dell'app prima
   che lo nascondessimo: quando ci sara' l'indirizzo giusto va aggiunto
   qui.

   type="button" non e' un dettaglio: in scheda prodotto questi
   cerchietti finiscono dentro il form di acquisto, e un bottone senza
   tipo e' un bottone di invio - aprire una spiegazione avrebbe mandato
   l'ordine. */
(function () {
  var SALDO = /saldo/i;
  var BONIFICO = /bonific/i;

  var contatore = 0;

  function testoBuono() {
    return 'Con pagamento a mezzo bonifico bancario riceverai un Buono Acquisto che potrai utilizzare subito, ' +
      'per effettuare un ordine di accessori che ti invieremo con la bici, oppure più avanti, entro 12 mesi.';
  }

  function testoRate() {
    return 'Pedala subito ed inizia a pagare fra 30 giorni in 20 rate Tan 0 Taeg 0 nessun costo aggiuntivo. ' +
      'Approvazione online immediata.';
  }

  function costruisci(etichetta, testo) {
    contatore++;
    var id = 'cube-info-' + contatore;

    var tasto = document.createElement('button');
    tasto.type = 'button';
    tasto.className = 'cube-info';
    tasto.textContent = 'i';
    tasto.setAttribute('aria-label', etichetta);
    tasto.setAttribute('aria-expanded', 'false');
    tasto.setAttribute('aria-controls', id);

    var pannello = document.createElement('p');
    pannello.className = 'cube-info__testo';
    pannello.id = id;
    pannello.hidden = true;
    pannello.textContent = testo;

    tasto.addEventListener('click', function (e) {
      e.preventDefault();
      var aperto = tasto.getAttribute('aria-expanded') === 'true';
      tasto.setAttribute('aria-expanded', aperto ? 'false' : 'true');
      pannello.hidden = aperto;
    });

    return { tasto: tasto, pannello: pannello };
  }

  /* mette la "i" in fondo a un elemento, una volta sola */
  function appendi(host, etichetta, testo) {
    if (!host || host.querySelector('.cube-info')) return;
    var pezzi = costruisci(etichetta, testo);
    host.appendChild(pezzi.tasto);
    host.appendChild(pezzi.pannello);
  }

  /* ---------- i due widget sotto il prezzo ---------- */

  function widget() {
    appendi(document.querySelector('.cube-rata'), 'Come funziona il pagamento a rate', testoRate());
    appendi(document.querySelector('.cube-voucher'), 'Come funziona il Buono Acquisto', testoBuono());
  }

  /* ---------- il bonifico del saldo, dentro la finestra ---------- */
  /* La casella si riconosce dal nome dell'elenco e dal valore, non
     dall'etichetta scritta: se Alberto toglie "(Buono Acquisto in
     omaggio)" dal testo, la "i" resta dov'e'.

     Il pannello sta DENTRO la riga, non dopo: subito sotto la riga ci
     va l'importo, che cube-campi.js sposta li' a ogni giro, e i due si
     contenderebbero il posto. Dentro la riga basta mandarlo a capo. */

  function saldo() {
    document.querySelectorAll('.ma-custom-field-group fieldset[data-field-name]').forEach(function (elenco) {
      if (!SALDO.test(elenco.getAttribute('data-field-name') || '')) return;

      elenco.querySelectorAll('input[type="checkbox"]').forEach(function (casella) {
        if (!BONIFICO.test(casella.value)) return;
        appendi(casella.closest('.ma-fieldset-option'), 'Come funziona il Buono Acquisto', testoBuono());
      });
    });
  }

  function run() {
    widget();
    saldo();
  }

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      run();
    });
  }

  function init() {
    run();
    if (!document.body) return;
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();